import React, { Fragment } from "react";
import FormControl from "@mui/material/FormControl";
import { InputLabel, MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import { Skeleton } from "@mui/material";
import { useVideoRatings } from "../cspServices";

const VideoRatingsSelect = props => {
  const { onChange, label = "Rating", value, valueFormat = "name" } = props;
  const ratings = useVideoRatings();

  return (
    <Fragment>
      {ratings.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <InputLabel htmlFor="content-audience">{label}</InputLabel>
          <Select
            value={value || ""}
            onChange={onChange}
            inputProps={{
              name: "video-ratings",
              id: "video-ratings",
            }}
          >
            <MenuItem value={null} key="no-rating">
              <i>None</i>
            </MenuItem>
            {ratings.data.map(rating => {
              return (
                <MenuItem
                  value={valueFormat === "name" ? rating.name : rating}
                  key={rating.name}
                >
                  {rating.display}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </Fragment>
  );
};

export default VideoRatingsSelect;
